var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6239 4.72069C17.417 3.9462 16.8071 3.33635 16.0326 3.12935C14.6287 2.75317 9 2.75317 9 2.75317C9 2.75317 3.37124 2.75317 1.96738 3.12935C1.19303 3.33635 0.583031 3.9462 0.376066 4.72069C0 6.12441 0 9.05328 0 9.05328C0 9.05328 0 11.9821 0.376066 13.3857C0.583031 14.1601 1.19303 14.7702 1.96738 14.9771C3.37124 15.3532 9 15.3532 9 15.3532C9 15.3532 14.6287 15.3532 16.0326 14.9771C16.8071 14.7702 17.417 14.1601 17.6239 13.3857C18 11.9821 18 9.05328 18 9.05328C18 9.05328 18 6.12441 17.6239 4.72069ZM7.19989 11.7533V6.35321L11.8763 9.05328L7.19989 11.7533Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.0532227)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.11b61c86a4b919544779727da1b515f8.svg";
export { ForwardRef as ReactComponent };